export default {
  SET_EMPLOYEES(state, employees) {
    state.employees = employees
  },
  ADD_EMPLOYEE(state, employee) {
    state.employees.unshift(employee)
  },
  UPDATE_EMPLOYEE(state, employee) {
    const index = state.employees.findIndex((t) => t.employeeId === employee.employeeId)
    Object.assign(state.employees[index], employee)
  },
  REMOVE_EMPLOYEE(state, employeeId) {
    const index = state.employees.findIndex((t) => t.employeeId === employeeId)
    state.employees.splice(index, 1)
  },
  SET_MUCKTYPE(state, muckTypes) {
    state.muckTypes = muckTypes
  },
  ADD_MUCKTYPE(state, muckType) {
    state.muckTypes.unshift(muckType)
  },
  UPDATE_MUCKTYPE(state, muckType) {
    const index = state.muckTypes.findIndex((t) => t.muckTypeId === muckType.muckTypeId)
    Object.assign(state.muckTypes[index], muckType)
  },
  REMOVE_MUCKTYPE(state, muckTypeId) {
    const index = state.muckTypes.findIndex((t) => t.muckTypeId === muckTypeId)
    state.muckTypes.splice(index, 1)
  },
  SET_EQUIPMENTS(state, equipments) {
    state.equipments = equipments
  },
  ADD_EQUIPMENT(state, equipment) {
    state.equipments.unshift(equipment)
  },
  UPDATE_EQUIPMENT(state, equipment) {
    const index = state.equipments.findIndex((t) => t.equipmentId === equipment.equipmentId)
    Object.assign(state.equipments[index], equipment)
  },
  REMOVE_EQUIPMENT(state, equipmentId) {
    const index = state.equipments.findIndex((t) => t.equipmentId === equipmentId)
    state.equipments.splice(index, 1)
  },
  SET_LOCATIONS(state, locations) {
    state.locations = locations
  },
  ADD_LOCATION(state, location) {
    state.locations.unshift(location)
  },
  UPDATE_LOCATION(state, location) {
    const index = state.locations.findIndex((t) => t.locationId === location.locationId)
    Object.assign(state.locations[index], location)
  },
  REMOVE_LOCATION(state, locationId) {
    const index = state.locations.findIndex((t) => t.locationId === locationId)
    state.locations.splice(index, 1)
  },
  ADD_TIMESHEET (state, timesheet) {
    state.timesheets.unshift(timesheet)
  },
  SET_TIMESHEETS(state, timesheets) {
    state.timesheets = timesheets
  },
  UPDATE_TIMESHEET(state, timesheet) {
    const timesheetIndex = state.timesheets.findIndex((t) => t.timesheetStagingEntryId === timesheet.timesheetStagingEntryId)
    Object.assign(state.timesheets[timesheetIndex], timesheet)
  },
  REMOVE_TIMESHEET(state, timesheetId) {
    const timesheetIndex = state.timesheets.findIndex((t) => t.timesheetStagingEntryId === timesheetId)
    state.timesheets[timesheetIndex].isDeleted = true;
  },
  ADD_FORECAST(state, forecast) {
    state.forecasts.unshift(forecast)
  },
  SET_FORECASTS(state, forecasts) {
    state.forecasts = forecasts
  },
  UPDATE_FORECAST(state, forecast) {
    const forecastIndex = state.forecasts.findIndex((t) => t.locationForecastId === forecast.locationForecastId)
    Object.assign(state.forecasts[forecastIndex], forecast)
  },
  REMOVE_FORECAST(state, locationForecastId) {
    const forecastIndex = state.forecasts.findIndex((t) => t.locationForecastId === locationForecastId)
    state.forecasts.splice(forecastIndex, 1)
  },
  SET_MUCKS(state, mucks) {
    state.mucks = mucks
  },
  SET_HAULINGS(state, haulings) {
    state.haulings = haulings
  },
  SET_FORECASTSTATS(state, forecast) {
    state.forecastStats = forecast
  },
  SET_FORECASTSTATSLIST(state, forecastStats) {
    state.forecastStatsList = forecastStats
  },
  SET_FORECASTPERIODLIST(state, periods) {
    state.forecastPeriodList = periods
  },
  SELECT_MUCK(state, muck) {
    state.selectedMuck = muck
  },
  ADD_MUCK(state, muck) {
    state.mucks.unshift(muck)
  },
  UPDATE_MUCK(state, muck) {
    const muckIndex = state.mucks.findIndex((t) => t.muckId === muck.muckId)
    Object.assign(state.mucks[muckIndex], muck)
  },
  REMOVE_MUCK(state, muckId) {
    const muckIndex = state.mucks.findIndex((t) => t.muckId === muckId)
    state.mucks.splice(muckIndex, 1)
  },
  SET_SAMPLES(state, samples) {
    state.samples = samples
  },
  UPDATE_SAMPLE(state, sample) {
    const sampleIndex = state.samples.findIndex((s) => s.sampleId === sample.sampleId)
    Object.assign(state.samples[sampleIndex], sample)
  },
  SET_LIMSSAMPLES(state, samples) {
    state.limsSamples = samples
  },
  UPDATE_LIMSSAMPLE(state, sample) {
    const sampleIndex = state.limsSamples.findIndex((t) => t.sampleNumber === sample.sampleNumber)
    Object.assign(state.limsSamples[sampleIndex], sample)
  },
  SET_MATERIALSUBTYPE(state, materialSubTypes) {
    state.materialSubTypes = materialSubTypes
  },
  ADD_MATERIALSUBTYPE(state, materialSubType) {
    state.materialSubTypes.unshift(materialSubType)
  },
  UPDATE_MATERIALSUBTYPE(state, materialSubType) {
    const index = state.materialSubTypes.findIndex((t) => t.materialSubTypeId === materialSubType.materialSubTypeId)
    Object.assign(state.materialSubTypes[index], materialSubType)
  },
  REMOVE_MATERIALSUBTYPE(state, materialSubTypeId) {
    const index = state.materialSubTypes.findIndex((t) => t.materialSubTypeId === materialSubTypeId)
    state.materialSubTypes.splice(index, 1)
  },

  SET_DESTINATIONS(state, destinationsList) {
    state.destinations = destinationsList
  },
  ADD_DESTINATION(state, destination) {
    state.destinations.unshift(destination)
  },
  UPDATE_DESTINATION(state, destination) {
    const index = state.destinations.findIndex((t) => t.id === destination.id)
    Object.assign(state.destinations[index], destination)
  },
  REMOVE_DESTINATION(state, id) {
    const index = state.destinations.findIndex((t) => t.id === id)
    state.destinations.splice(index, 1)
  },

  SET_REMUCK_FORECASTS(state, remuckForecasts) {
    state.remuckForecasts = remuckForecasts;
  },
  ADD_REMUCK_FORECAST(state, item) {
    state.remuckForecasts.unshift(item);
  },
  UPDATE_REMUCK_FORECAST(state, item) {
    const index = state.remuckForecasts.findIndex((t) => t.id === item.id);
    Object.assign(state.remuckForecasts[index], item);
  },

  SET_NSR_FORECASTS(state, nsrForecasts) {
    state.nsrForecasts = nsrForecasts;
  },
  ADD_NSR_FORECAST(state, item) {
    state.nsrForecasts.unshift(item);
  },
  UPDATE_NSR_FORECAST(state, item) {
    const index = state.nsrForecasts.findIndex((t) => t.id === item.id);
    Object.assign(state.nsrForecasts[index], item);
  },

  SET_ANNUAL_FORECASTS(state, items) {
    state.annualForecasts = items;
  },
  ADD_ANNUAL_FORECAST(state, item) {
    state.annualForecasts.unshift(item);
  },
  UPDATE_ANNUAL_FORECASTS(state, items) {
    items.forEach(item => {
      const index = state.annualForecasts.findIndex((t) => t.annualLocationForecastId === item.annualLocationForecastId);
      if (index >= 0) {
        Object.assign(state.annualForecasts[index], item);
      }
    });
  },
  REMOVE_ANNUAL_FORECASTS(state, ids) {
    state.annualForecasts = state.annualForecasts.filter((t) => !ids.includes(t.annualLocationForecastId));
  }
}
